module.exports = __webpack_public_path__ + "img/15.543f5f62.jpg";